import React from 'react';
import propTypes from 'prop-types';
//import thumbnails from '../../data/thumbnails';

import './NewsImageBox.css';

const getHeroImage = function(images) {
  const defaultImage = '';
  return ((images || []).filter(im => im.hero)[0] || (images || [])[0]) || defaultImage;
}

const formatDate = function(dateString) {
  const options = { /*weekday: 'long',*/ year: 'numeric', month: '2-digit', day: '2-digit' };
  const date = new Date(dateString);

  return date.toLocaleDateString('en-GB', options);
}

const listCategories = function(categoriesArray) {
  return (categoriesArray || []).join(', ');
}

const NewsImageBox = props => (
  <a className={`NewsImageBox ${props.isLargeBox ? 'large' : 'small'}`} key={props._id} onClick={props.onClick.bind(this, props._id)}>
    <section className="NewsImageBox__wrapper">
      <section className={'NewsImageBox__progressBarContainer'}>
        <div className={'NewsImageBox__progressBar'} />
      </section>
      <img className={'NewsImageBox__image'} src={getHeroImage(props.images).data} alt={getHeroImage(props.images).filename} />
      <section className={'NewsImageBox__itemTextArea'}>
        <section className="NewsImageBox__details">
          {props.categories && <section className="NewsImageBox__detailsCategories">{listCategories(props.categories)}</section>}
          {props.date && <section className="NewsImageBox__detailsDate">{formatDate(props.date)}</section>}
        </section>
        <h4 className={'NewsImageBox__header'}>
          {props.title}
        </h4>
        <div className={'NewsImageBox__subheader'}>
          {props.subtitle}
        </div>
      </section>
    </section>
  </a>
);

export default NewsImageBox;

NewsImageBox.propTypes = {
  images: propTypes.array,
  title: propTypes.string.isRequired,
  categories: propTypes.array,
  // date: propTypes.string.isRequired,
  isLargeBox: propTypes.bool,
  onClick: propTypes.func.isRequired,
  _id: propTypes.string.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/NewsImageBox/NewsImageBox.js